import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "flag-icon flag-icon-us" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "dropdown-item active"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flag-icon flag-icon-us mr-2" }),
  /*#__PURE__*/_createTextVNode(" English ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "dropdown-item"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flag-icon flag-icon-de mr-2" }),
  /*#__PURE__*/_createTextVNode(" German ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "dropdown-item"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flag-icon flag-icon-fr mr-2" }),
  /*#__PURE__*/_createTextVNode(" French ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "dropdown-item"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flag-icon flag-icon-es mr-2" }),
  /*#__PURE__*/_createTextVNode(" Spanish ")
], -1)

export function render(_ctx, _cache) {
  const _component_app_dropdown = _resolveComponent("app-dropdown")

  return (_openBlock(), _createBlock(_component_app_dropdown, null, {
    "dropdown-button": _withCtx(() => [
      _hoisted_1
    ]),
    "dropdown-menu": _withCtx(() => [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5
    ]),
    _: 1
  }))
}